import {useQuery} from 'react-query'
import {ClientEditModalForm} from './ClientEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getClientById} from '../core/_requests'

const ClientEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: client,
    error,
  } = useQuery(
    `${QUERIES.CLIENTS_LIST}-client-${itemIdForUpdate}`,
    () => {
      return getClientById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ClientEditModalForm isClientLoading={isLoading} client={{id: undefined}} />
  }

  if (!isLoading && !error && client) {
    return <ClientEditModalForm isClientLoading={isLoading} client={client} />
  }

  return null
}

export {ClientEditModalFormWrapper}
